const BASE_10 = 10;

export function getPrecision(number: number): number {
  const n = Math.abs(number);
  // Zero short-circuit: the while loop below never terminates for n = 0.
  if (n == 0) {
    return 0;
  }
  let precision = -getScale(n);
  while (round(n, precision) != n) {
    precision++;
  }
  return precision;
}

export function getScale(number: number) {
  let exp = Math.floor(Math.log(Math.abs(number)) / Math.LN10);
  if (Math.pow(BASE_10, exp + 1) == Math.abs(number)) exp++; //Needed to fix rounding errors
  return exp;
}

export function round(number: number, precision = 0) {
  const factor = Math.pow(BASE_10, precision);
  number = Math.round(number * factor) / factor;
  return number;
}

/**
 * Round `number` up to `precision` decimal places. Mirrors the legacy
 * `Calculator.ceil` global.
 */
export function ceil(number: number, precision = 0): number {
  const factor = Math.pow(BASE_10, precision);
  return Math.ceil(number * factor) / factor;
}

/**
 * Round `number` down to `precision` decimal places. Mirrors the legacy
 * `Calculator.floor` global.
 */
export function floor(number: number, precision = 0): number {
  const factor = Math.pow(BASE_10, precision);
  return Math.floor(number * factor) / factor;
}
